import type { Handlers } from '@/types/Metrics';

export default function (args: Handlers['facebook']) {
  const { parameters } = useParameters();

  if (!parameters.value?.pixel_id) {
    return;
  }

  const [eventType, eventName, eventParameters] = args;

  try {
    trackFacebookEvent(eventType, eventName, eventParameters);
  } catch (err) {
    console.error('Error executing Facebook tracking:', err);
  }
}

function trackFacebookEvent(
  eventType: string,
  eventName: string,
  eventParameters?: Record<string, any>,
): void {
  if (!isFacebookPixelAvailable()) {
    console.warn('Facebook tracking: fbq is not available');

    return;
  }

  try {
    (window as any).fbq(eventType, eventName, eventParameters);
  } catch (error) {
    console.error('Error executing Facebook pixel event:', error);
  }
}

function isFacebookPixelAvailable(): boolean {
  return (
    typeof window !== 'undefined' && typeof (window as any).fbq === 'function'
  );
}
